const firebaseConfig = {
    apiKey: "AIzaSyCkoOOpVIU1NrXnBrB_uDZl6f_ybcdytl0",
    authDomain: "flexline-app.firebaseapp.com",
    projectId: "flexline-app",
    storageBucket: "flexline-app.appspot.com",
    messagingSenderId: "1003867931388",
    appId: "1:1003867931388:web:cbb3399aaff3ec0b510d79",
    measurementId: "G-WHBSNX5KRF"
};
export default firebaseConfig
